import React, { memo, useEffect } from "react";
import Item from "./Item";

const List = memo(({ users, handleDelete }) => {

  useEffect(() => {
    //console.log("List Render");
  });

  return (
    <ul className="iotGrid-container">
      {users.map((user) => (
        // <div className="iotGrid-item">
        <Item key={user.id} user={user} handleDelete={handleDelete} />
        // </div>
      ))}
    </ul>
  );
});

export default List;
